<template>
  <div class="swiper-box">
    <swiper :options="swiperOption">
      <swiper-slide v-for="(item, key) in swiperArray" :key="key">
        <img :src="item.src" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <!-- <div class="swiper-button-prev" slot="button-prev">
      <img src="../../assets/img/pc/icon/icon-left.png" alt="" />
    </div>
    <div class="swiper-button-next" slot="button-next">
      <img src="../../assets/img/pc/icon/icon-right.png" alt="" />
    </div> -->
  </div>
</template>

<script>
/*组件方式引用*/
import "swiper/dist/css/swiper.css"; ////这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: ["swiperArray"],
  data() {
    //这里存放数据
    return {
      swiperOption: {
        // NotNextTick is a component's own property, and if notNextTick is set to true, the component will not instantiate the swiper through NextTick, which means you can get the swiper object the first time (if you need to use the get swiper object to do what Things, then this property must be true)
        // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        //设定初始化时slide的索引
        initialSlide: 0,
        // slides的滑动方向，可设置水平(horizontal)或垂直(vertical)。
        direction: "horizontal",
        // 设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        grabCursor: false,
        // 自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。
        autoHeight: true,
        pagination: {
          el: ".swiper-pagination",
          //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
          clickable: true,
          clickableClass: "my-pagination-clickable",
        },
        //自动播放
        autoplay: {
          delay: 1500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        //循环播放
        loop: true,
        // mousewheelControl: true,
        autoplayDisableOnInteraction: false,
      },
    };
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  methods: {},
};
</script>
<style lang="less" scoped>
.swiper-box {
  height: 550px;
  overflow: hidden;
  .swiper-container {
    height: 550px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
